import React, { useEffect, useState } from "react";
import DraggableModal from "../../UI/DraggableModal";
import { Modal, Button } from "react-bootstrap";
import useAPI from "../../../hooks/useAPI";
import './ModalMoveProject.less'
import { Tooltip } from "@mui/material";

export default function ModalMoveProject({show, onHide, onConfirm}){
    const [strategyOptions, setStrategyOptions] = useState([]);
    const [selectedStrategy, setSelectedStrategy] = useState(null);
    const [showTooltip, setShowTooltip] = useState(false)
    const api = useAPI()

    useEffect(() => {
        const getStrategies = async () => {
            const moveOptions = await api.get('/stats/projs/structure?year=2025');
            const filtered = moveOptions.filter(item => item.entityType !== 'none');
    
            const parents = filtered.filter(item => !item.parentId);
            const children = filtered.filter(item => item.parentId);
    
            parents.sort((a, b) => (a.num || "").localeCompare(b.num || ""));
    
            const flatList = [];
    
            parents.forEach(parent => {
                flatList.push(parent);
    
                const sortedChildren = children
                    .filter(child => child.parentId === parent.id)
                    .sort((a, b) => (a.num || "").localeCompare(b.num || ""));
    
                flatList.push(...sortedChildren);
            });
    
            setStrategyOptions(flatList);
        };
    
        getStrategies();
    }, []);
    

    const handleSelectStrategy = (option) => {
        setSelectedStrategy(prevState => prevState?.id !== option.id ? option : null)
    }

    const handleClose = () => {
        setSelectedStrategy(null)
        onHide()
    }

    return <DraggableModal className="moveProject" size='lg' headerNode='Выберите СП или политику' show={show} onHide={handleClose}>
        <Modal.Body>
            <div className="d-flex flex-column moveProject-strategies">
                {strategyOptions.map((strategy) => <div
                    className="pr-4 py-3 moveProject-strategy"
                    onClick={() => handleSelectStrategy(strategy)}
                    style={{backgroundColor: selectedStrategy?.id === strategy.id ? '#DCE7FF' : 'white', paddingLeft: strategy.entityType === 'portf' ? 48 : 24}}
                    key={strategy.id}
                >
                    <p>{strategy.num || ''} {strategy.name}</p>
                </div>)}
            </div>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-end">
            <Button variant="outline-secondary" onClick={handleClose}>Отменить</Button>
            <Tooltip
                title='Сначала нужно выбрать СП/Политику'
                placement="top"
                onOpen={() => setShowTooltip(!selectedStrategy)}
                onClose={() => setShowTooltip(false)}
                open={showTooltip}
            >
                <div>
                    <Button variant="outline-success" disabled={!selectedStrategy} onClick={() => onConfirm(selectedStrategy)}>Перенести</Button>
                </div>
            </Tooltip>
        </Modal.Footer>
    </DraggableModal>
}